export interface LoginPageProps {
}
 
const LoginPage: React.FC<LoginPageProps> = (props: LoginPageProps) => {
    return ( 
        <>
        
        </>
     );
}
 
export default LoginPage;